import React from 'react'

import SubprogramRunner from './SubprogramRunner'

// Admin-only preview entry point. Renders the exact same runner the learners
// use, but in `preview` mode so it pulls UNPUBLISHED content from the staging
// endpoints and returns to the admin detail page on exit. Lets admins see
// their work without first publishing it to live.
export default function SubprogramRunnerPreview(props) {
    return <SubprogramRunner {...props} preview />
}
